










































import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppendixFileDto, downloadFile, upFile, addAttachment, delAttachment, getSyDictDataInfo } from '@/api/commonConfig'
import AppendixName from '@/components/AppendixName/index.vue'
import { Getter } from 'vuex-class'
import { downFileToSystemFile } from '@/utils/h5ToApp'

@Component({
    name: 'AppendixDialog',
    components: {AppendixName}
})
export default class AppendixDialog extends Vue {
    @Getter companyId!: string
    @Getter userId!: string
    @Prop({default: ''}) propCompanyId?: string

    showDialog = false
    // 上传文件类别 1公司log 2商品轮播图 3商品推荐图 4商品视频 5商品内容HTML文件 6订单附件
    fileType = '1'
    fileData: AppendixFileDto[] = []
    maxSize = 5 // 附件上限值 由后台配置
    count: AppendixFileDto = {}
    businessId = '' // 业务id
    currRouteId = '' // 详情接口返回参数,删除和追加订单附件时需要传参

    type = '1' // 1订单 2 退单

    attachmentMaxNum = 10 // 文件上传最大数量值

    show (data: { fileType?: string, orderFile: AppendixFileDto[], orderId?: string, currRouteId?: string, type: string }) {
        this.showDialog = true
        this.fileType = data.fileType || '6'
        this.type = data.type || '1'
        if (data) {
            this.fileData = data.orderFile || []
            this.businessId = data.orderId
            this.currRouteId = data.currRouteId
        }
        this.getSyDictDataInfo()
    }

    /**
     *  获取上传文件最大数量值
     */
    getSyDictDataInfo () {
        let param = {
            dictTypeId: 'attachmentMaxNum'
        }
        getSyDictDataInfo(param).then(res => {
            this.attachmentMaxNum = Number(res.data[0].dataId)
        })
    }

    cancel () {
        this.showDialog = false
    }

    /*
     * 商品主图固定为7张，单张图片不得超过1M；每个商品视频大小不能超过20M，商品描述固定10M内容大小。单个商品文件总容量接近37M。
     2.订单附件：
     每个订单只能上传一个附件，附件大小限制为3M，支持上传PDF、Word、Excel、Txt、JPG、PNG、BMP、GIF、RAR、ZIP格式。
     * h5 上传
     * */

    // 与原生交互上传文件
    beforeUpload () {
        const data = {
            companyId: this.propCompanyId,
            fileType: this.fileType,
        }
        this.$bridge.callHandler('uploadFile', data, (res) => {
            const data = !res ? {} : JSON.parse(res)
            let nameArr = data.filePath.split('/')
            // 非新增订单情况
            if (!this.$checkIsEmpty(this.businessId)) {
                let param = {
                    userId: this.userId,
                    businessId: this.businessId,
                    currRouteId: this.currRouteId,
                    attachmentName: nameArr[nameArr.length - 1],
                    attachmentUrl: data.filePath,
                    attachmentSize: data.fileSize,
                    type: this.type
                }
                addAttachment(param).then(res => {
                    if (res.code === '000000') {
                        this.fileData.unshift({
                            orderFileName: nameArr[nameArr.length - 1],
                            orderFileUrl: data.filePath,
                            orderFileSize: data.fileSize,
                            createUser: this.userId,
                            attachmentId: res.data.attachmentId
                        })
                        this.$emit('getUploadInfo', this.fileData)
                    } else {
                        this.$toast(res.msg)
                    }
                })
            } else {
                this.fileData.unshift({
                    orderFileName: nameArr.pop(),
                    orderFileUrl: data.filePath,
                    orderFileSize: data.fileSize,
                    createUser: this.userId,
                })
            }
        })
    }


    confirmFunc () {
        let fileList = this.fileData
        this.$emit('getUploadInfo', this.fileData)
        this.showDialog = false
    }

    deleteAppendix (index: number, file: AppendixFileDto) {
        // 非新增订单情况
        if (this.$checkIsEmpty(this.businessId)) {
            this.fileData.splice(index, 1)
        } else {
            if (file.createUser !== this.userId) return false
            let param = {
                companyId: this.companyId,
                currRouteId: this.currRouteId,
                attachmentId: file.attachmentId,
                type: this.type
            }
            delAttachment(param).then(res => {
                this.fileData.splice(index, 1)
                this.$toast('删除成功')
            })
            this.$emit('deleteOrderAttachFile', index)
        }
    }

    downloadFunc (index: number) {
        const data = {
            filePath: encodeURI(window.location.origin + this.$downloadUrl(this.fileData[index].orderFileUrl)), // 完整的url地址
            fileName: this.fileData[index].orderFileName
        }
        // 与原生交互下载
        downFileToSystemFile(data)
        // h5调用下载接口下载
    }
}
